import superagent from 'superagent'

export const friendListSet = friend => ({
  type: 'FRIEND_LIST_SET',
  payload: friend
})

export const friendCreate = friend => ({
  type: 'FRIEND_LIST_CREATE',
  payload: friend
})

export const friendUpdate = friend => ({
  type: 'FRIEND_LIST_UPDATE',
  payload: friend
})

export const removeFriend = friend => (dispatch, getState, token) => {
  const updatedList = getState().friendList.filter(listFriend => listFriend.id !== friend.id)
  dispatch(friendListSet(updatedList))
  superagent
    .delete(`${__API_URI_3__}/UserFollowing/Unfollow/${friend.id}`)
    .set('Authorization', `Bearer ${token}`)
    .set('Platform', 'Web')
    .set('Version', `${__version__}`)
    .end((err, res) => {
      if (err) {
        console.error('UserFollowing/Unfollow action failed', err)
      } else {
        console.log('unfollow successful')
      }
    })
}

export const markFriendListRead = () => (dispatch, getState, token) => {
  let friendList = getState().friendList
  friendList.map(f => {
    if (f.isNew) {
      f.isNew = false
    }
  })

  dispatch(friendListSet(friendList))
}

